"use client";

import { useState } from "react";
import { faRandom, faSpinner } from "@fortawesome/pro-solid-svg-icons";

import { Button } from "..";

import randomGalleryPage from "./actions/random-page";

type RandomPageButtonProps = {
  totalAnimations: number;
};

const RandomPageButton = ({ totalAnimations }: RandomPageButtonProps) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const onRandomButtonClicked = async () => {
    setIsSubmitting(true);
    await randomGalleryPage(totalAnimations);
    setIsSubmitting(false);
  };

  if (isSubmitting) {
    return (
      <Button
        onClick={onRandomButtonClicked}
        disabled
        icon={faSpinner}
      >
        Randomising
      </Button>
    );
  }

  return (
    <Button
      onClick={onRandomButtonClicked}
      disabled={totalAnimations === 0}
      icon={faRandom}
    >
      Random
    </Button>
  );
};

export { RandomPageButton };
